import {useState} from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard} from '../../../../_metronic/helpers'
import {DocumentTrayContext} from './DocumentTrayContexts'
import {DocumentTrayTableHeader} from './main/DocumentTrayTableHeader'
import {DocumentTrayTabs} from './main/DocumentTrayTabs'
import {PreviewDocumentModal} from './preview-document-modal/PreviewDocumentModal'

const documentTrayBreadcrumbs = [
  {
    title: 'Documentos',
    path: '/documentos/bandeja',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DocumentTrayPage = () => {
  const [isPreviewDocumentModalOpen, setPreviewDocumentModalStatus] = useState(false)
  const [keyname, setKeyname] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [fromPreviewTab, setFromPreviewTab] = useState({
    showSignature: false,
    signCeo: false,
    idUserSign: '',
  })
  const [filename, setFilename] = useState('')

  const openPreviewDocumentModal = () => {
    setPreviewDocumentModalStatus(true)
  }

  const closePreviewDocumentModal = () => {
    setPreviewDocumentModalStatus(false)
  }

  const documentTrayValue = {
    isPreviewDocumentModalOpen,
    openPreviewDocumentModal,
    closePreviewDocumentModal,
    keyname,
    setKeyname,
    searchTerm,
    setSearchTerm,
    fromPreviewTab,
    setFromPreviewTab,
    filename,
    setFilename,
  }

  return (
    <>
      <DocumentTrayContext.Provider value={documentTrayValue}>
        <BasicBreadcrumbs
          breadcrumbs={documentTrayBreadcrumbs}
          fallbackTitle='Bandeja de Documentos'
        />
        <KTCard>
          <DocumentTrayTableHeader />
          <DocumentTrayTabs />
        </KTCard>
        <PreviewDocumentModal />
      </DocumentTrayContext.Provider>
    </>
  )
}

export {DocumentTrayPage}
